module.exports = __webpack_public_path__ + "static/pattern-animal.80107a44.svg";